import StaffMemberByPerson from './StaffMemberByPerson.container';
import context from './StaffMemberByPerson.context';

export default StaffMemberByPerson;
export { context };
export * from './StaffMemberByPerson.container';
export * from './StaffMemberByPerson.context';
